import { Airport } from '../models/response';
import { ApiClient } from '../util/api-client';

export class AirportsService {
    public static async list() {
        return ApiClient.get<Airport[]>('airports');
    }
}
